export default __webpack_public_path__ + "static/media/pin-red.c1e6a62d.svg";